<template>
    <div>
      <el-dialog title="审批" :visible.sync="dialogVisible" :show-close = "false" width="50%">
        <el-form label-width="80" :inline="true">
          <el-form-item label="机构:">
            <el-select v-model="postModel.orgId" placeholder="请选择机构" clearable @change="getProcess">
              <el-option v-for="item in orgs" :key="item.id" :label="item.orgName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应用:">
            <el-select v-model="postModel.appCode" placeholder="请选择应用" clearable @change="getProcess">
              <el-option v-for="item in apps" :key="item.appCode" :label="item.appName" :value="item.appCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="流程:">
            <el-select v-model="postModel.processCode" placeholder="请选择流程" clearable>
              <el-option v-for="item in process" :key="item.processCode" :label="item.processName" :value="item.processCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="query(1)" type="primary" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>

        <div>
          <div v-if="Approver.length > 0">
            <el-card>
              <div slot="header" class="clearfix">
                <div class="header_img">
                  <img src="" @error="errorImg($event,'avatar')">
                </div>
                <div class="header_desc" >
                  <p v-if="userName">{{userName}}</p>
                  <p class="text-sub">等待{{Approver[0].userName}}审批</p>
                </div>
              </div>
              <!--<el-row :gutter="16">-->
              <!--<el-col :span="4" class="list_name">所在部门</el-col>-->
              <!--<el-col :span="20">前端组</el-col>-->
              <!--</el-row>-->
            </el-card>
            <el-card class="box-card">
              <div class="processManager">
                <div class="process_item" >
                  <div class="processToggle">
                    <div class="name" :title="'姓名'" v-if="userName">{{userName}}</div>
                  </div>
                  <div class="step_box">
                    <span class="name">我</span>
                    <span class="text-warn">发起申请</span>
                  </div>
                </div>
                <div class="process_item" v-for="(item,index) in Approver" :key="index">
                  <div class="processToggle">
                    <div class="name" :title="'姓名'">{{item.userName}}</div>
                    <p class="grade_box" :title="'主管级别'">第{{index+1}}审批人</p>
                  </div>
                  <div class="step_box">
                    <span class="name">{{item.userName}}</span>
                    <span class="text-warn">审批中</span>
                  </div>
                </div>
              </div>
              <!--<div class="processManager">-->
              <!--<div class="process_item" v-for="(item,index) in Approver" :key="index">-->
              <!--<div class="processToggle">-->
              <!--<div class="name" :title="'张三'">张三</div>-->
              <!--<p v-if="index>0" class="grade_box" :title="'主管级别'">第{{index+1}}级主管</p>-->
              <!--</div>-->
              <!--<div class="step_box">-->
              <!--<span class="name">我</span>-->
              <!--<span :class="{'text-warn':index == 1}">发起申请{{index}}</span>-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
            </el-card>
          </div>
          <div v-else="Approver.length == 0">
            <el-card>
              <div>
                当前机构没有设置审批人<br/>
                请选择上一级机构,或者<br/>
                联系管理员维护机构节点<br/>
                的审批人!<br/>
              </div>
            </el-card>
          </div>

        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="processTo()">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
  export default {
    props: {
      dialogVisible:false,
      parentModel: {
        type: Object,
        default() {
          return {
            //所属应用
            appCode:'',
            //所属机构
            orgId:'',
            //所属流程
            processCode:'',
          }
        }
      },
    },
    data() {
      return {
        postModel: {
          appCode:'',
          orgId:'',
          processCode:'',
        },
        userName:this.$store.state.userInfo.userName,
        apps:[],
        orgs:[],
        process:[],
        //审批人列表
        Approver:[],
      };
    },
    mounted() {
      let vm = this;
      if(vm.parentModel.orgId === ''){
        vm.parentModel.orgId = this.$store.state.userInfo.orgId;
      }
      vm.postModel = _.cloneDeep(vm.parentModel);
      vm.getApps();
      vm.getOrg();
      vm.getProcess(1);
      vm.query();
    },
    methods:{
      //查询应用
      getApps(){
        let vm = this;
        var sourceList =window.apps;
        for(var t in sourceList){
          let obj = {
            appCode:sourceList[t].appCode,
            appName:sourceList[t].appName,
          };
          vm.apps.push(obj);
        }
      },

      //查询父级机构
      getOrg(){
        let vm = this;
        http.get(InterfacePrefix['platform'] + "/api/orgs/parents/"+vm.postModel.orgId).then(function (xhr) {
          if (!xhr.data.code) {
            vm.orgs = xhr.data
          }
        })
      },
      //查询流程
      getProcess(type){
        let vm = this;
        http.get(InterfacePrefix['platform'] + "/processOrg/findByParam",{params: vm.postModel}).then(function (xhr) {
          if (!xhr.data.code) {
            if (type !== 1) {
              vm.postModel.processCode = '';
            }
            vm.process = xhr.data.data;
          }
        })

      },
      processTo(){
        let vm = this;
        vm.$emit('processTo');
      },
      submit(){
        let vm = this;
        vm.$emit('submit',vm.Approver);
      },
      query(type){
        let vm = this;
        if (type === 1) {
          if (vm.postModel.orgId === '') {
            vm.$message.warning({
              showClose: true,
              message: '请选择上级机构!'
            });
            return;
          }
          if (vm.postModel.appCode === '') {
            vm.$message.warning({
              showClose: true,
              message: '请选择应用!'
            });
            return;
          }
          if (vm.postModel.processCode === '') {
            vm.$message.warning({
              showClose: true,
              message: '请选择流程!'
            });
            return;
          }
        }
        if(vm.postModel.orgId !== '' && vm.postModel.appCode !== '' && vm.postModel.processCode !== ''){
          http.get(InterfacePrefix['platform'] + "/processOrg/findOne",{params: vm.postModel}).then(function (xhr) {
            if (!xhr.data.code) {
              if (xhr.data.data.processApprovers) {
                vm.Approver = xhr.data.data.processApprovers
              }
            }
          });
        }
      },
    }
  };
</script>
<style lang="less" scoped>
  .header_img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    float: left;
    img{
      max-width: 100%;
    }
  }
  .header_desc{
    margin-left: 66px;
    line-height: 22px;
    padding-top: 3px;
    p:first-child{
      font-size: 16px;
    }
    .text-sub{
      color: #dea862;
    }
  }
  .list_name{
    text-align: right;
    color: #999;
  }
  .box-card{
    margin-top: 16px;
  }
  .processManager {
    position: relative;
    &:after {
      content: '';
      position: absolute;
      left: 40px;
      top: 0;
      height: 100%;
      width: 2px;
      background: #e6e6e6;
      z-index: 0;
    }
    .process_item{
      display: flex;
      .step_box{
        line-height: 50px;
      }
    }
    .process_item:last-child .processToggle{
      margin-bottom: 0;
    }
    .processToggle {
      cursor: pointer;
      position: relative;
      z-index: 1;
      margin-bottom: 66px;
      width: 80px;
      text-align: center;
      .name{
        width: 50px;
        height: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 50px;
        border-radius: 50%;
        background: #3296fa;
        color: #fff;
        margin: 0 auto;
      }
      .grade_box{
        color: #3296fa;
        background: #e6f4ff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .text-warn{
      color: #dea862;
    }
  }
</style>



// WEBPACK FOOTER //
// src/commonplugin/commitProcess.vue